module.exports = __webpack_public_path__ + "media/images/icon/woman-ad59f65d31b28ff34ec4da00f61e8c82.svg";